<template>
  <div v-if="form.active == '0' && auth.user.role_id != 1">
    <h2 class="text-2xl text-center font-bold">El formulario está entregado</h2>
  </div>
  <div>
    <Head title="Editar formulario" />
    <div class="flex flex-wrap justify-between w-full mb-8">
      <h1 class="text-3xl font-bold">
        <Link v-if="auth.user.role_id == 1" class="text-orange-400 hover:text-orange-600" href="/formularios">Formularios</Link>
        <span class="text-orange-400 font-medium">/</span>
        {{ form.organization }}
      </h1>
      <div v-if="auth.user.role_id != 3" class="flex my-2 md:my-0">
        <span v-if="form.active == '0'" class="px-4 py-2 rounded-full text-green-500 bg-green-200 font-semibold text-sm flex align-center w-max active:bg-gray-300 transition duration-300 ease">
          <p class="font-bold">Formulario entregado</p>
          <p v-if="form.active == '0'" class="ml-2 cursor-pointer" @click.prevent="reactivate">
            Reactivar
          </p>
        </span>
        <span v-if="form.active == '1'" class="px-4 py-2 rounded-full text-red-500 bg-red-200 font-semibold text-sm flex align-center w-max active:bg-gray-300 transition duration-300 ease">
          Formulario sin entregar
        </span>
      </div>
      <div v-if="form.active == '1' || auth.user.role_id == 1" class="my-2 md:my-0">
        <button class="btn-indigo" @click.prevent="update">
          <span>Guardar</span>
        </button>
        <button v-if="form.active == '1'" class="btn-orange ml-2" @click.prevent="save">
          <span>Enviar</span>
        </button>
      </div>
    </div>
    <div class="lg:flex">
      <div class="overflow-hidden">
        <div class="px-8 py-4 shadow rounded-t bg-gray-50 border-t border-gray-100">
          <h2 class="text-2xl font-bold">Declaración mensual</h2>
        </div>
        <div class="bg-white shadow font-bold overflow-x-auto p-4">
          <form @submit.prevent="update">
            <div class="flex flex-wrap">
              <text-input v-model="form.date" label="Fecha" disabled class="pb-2 pr-6 w-full lg:w-1/2" placeholder="Fecha" />
              <text-input v-model="form.organization" label="Oficina" disabled class="pb-2 pr-6 w-full lg:w-1/2" placeholder="Oficina" />
              <text-input v-model="form.codeBDT" label="Código BDT" disabled class="pb-2 pr-6 w-full lg:w-1/2" placeholder="Código BDT" />
              <text-input v-model="form.signatures_month" label="Firmas mes" :disabled="form.active == '0' && auth.user.role_id != 1" :error="form.errors.signatures_month" class="pb-2 pr-6 w-full lg:w-1/2" placeholder="Firmas mes" />
              <text-input v-model="form.active_agents" label="Agentes activos" :disabled="form.active == '0' && auth.user.role_id != 1" :error="form.errors.active_agents" class="pb-2 pr-6 w-full lg:w-1/2" placeholder="Agentes activos" />
              <text-input v-model="form.total_orders_month" label="Encargos Kiron totales mes" :disabled="form.active == '0' && auth.user.role_id != 1" :error="form.errors.total_orders_month" class="pb-2 pr-6 w-full lg:w-1/2" placeholder="Encargos Kiron totales mes" />
              <text-input v-model="form.number_organizations" label="Nº oficinas Tecnocasa" :disabled="form.active == '0' && auth.user.role_id != 1" :error="form.errors.number_organizations" class="pb-2 pr-6 w-full lg:w-1/2" placeholder="Nº oficinas Tecnocasa" />
              <text-input v-model="form.contacts" label="Contactos" :disabled="form.active == '0' && auth.user.role_id != 1" :error="form.errors.contacts" class="pb-2 pr-6 w-full lg:w-1/2" placeholder="Contactos" />
            </div>
          </form>
        </div>
        <div class="px-8 py-4 shadow rounded-b bg-gray-50 border-t border-gray-100">
          <h3 class="text-xl font-bold">Oficinas Tecnocasa asignadas</h3>
        </div>
        <div class="bg-white shadow font-bold overflow-x-auto p-4">
          <table class="w-full text-center">
            <thead class="bg-gray-500 text-white">
              <tr>
                <th class="px-4 py-2">Código BDT</th>
                <th class="px-4 py-2">Razón social</th>
                <th class="px-4 py-2">Total citas ventas</th>
                <th class="px-4 py-2">Citas aportadas</th>
                <th class="px-4 py-2">Estudios financieros</th>
                <th class="px-4 py-2">Propuestas aceptadas</th>
                <th class="px-4 py-2">Encargos Kiron</th>
                <th class="px-4 py-2">Firmas</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(code, index) in form.codes" :key="index">
                <tr :id="`code-${code.id}`">
                  <td :class="`border px-4 p-4 bg-gray-200 ${auth.user.role_id == 1 ? 'flex items-center justify-center' : ''}`">
                    {{ code.name }}
                    <button v-if="auth.user.role_id == 1" class="btn-indigo ml-2 p-2 w-100" @click.prevent="detach(code.id)">
                      <svg class="w-4 h-4 fill-current text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                        <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
                      </svg>
                    </button>
                  </td>
                  <td class="border px-4 py-2">{{ code.business_name }}</td>
                  <td class="border px-4 py-2">
                    <text-input
                      v-model="code.total_appointments_sale"
                      :error="errors && typeof code.total_appointments_sale == 'object' || errors && code.total_appointments_sale == '' ? 'Campo obligatorio' : ''"
                      type="number"
                      :disabled="form.active == '0' && auth.user.role_id != 1"
                      class="w-full"
                    />
                  </td>
                  <td class="border px-4 py-2">
                    <text-input
                      v-model="code.contributed_citations"
                      :error="errors && typeof code.contributed_citations == 'object' || errors && code.contributed_citations == '' ? 'Campo obligatorio' : ''"
                      type="number"
                      :disabled="form.active == '0' && auth.user.role_id != 1"
                      class="w-full"
                    />
                  </td>
                  <td class="border px-4 py-2">
                    <text-input
                      v-model="code.financial_studies"
                      :error="errors && typeof code.financial_studies == 'object' || errors && code.financial_studies == '' ? 'Campo obligatorio' : ''"
                      type="number"
                      :disabled="form.active == '0' && auth.user.role_id != 1"
                      class="w-full"
                    />
                  </td>
                  <td class="border px-4 py-2">
                    <text-input
                      v-model="code.proposals_accepted"
                      :error="errors && typeof code.proposals_accepted == 'object' || errors && code.proposals_accepted == '' ? 'Campo obligatorio' : ''"
                      type="number"
                      :disabled="form.active == '0' && auth.user.role_id != 1" class="w-full"
                    />
                  </td>
                  <td class="border px-4 py-2">
                    <text-input
                      v-model="code.orders"
                      :error="errors && typeof code.orders == 'object' || errors && code.orders == '' ? 'Campo obligatorio' : ''"
                      type="number"
                      :disabled="form.active == '0' && auth.user.role_id != 1" class="w-full"
                    />
                  </td>
                  <td class="border px-4 py-2">
                    <text-input
                      v-model="code.mortgages"
                      :error="errors && typeof code.mortgages == 'object' || errors && code.mortgages == '' ? 'Campo obligatorio' : ''"
                      type="number"
                      :disabled="form.active == '0' && auth.user.role_id != 1" class="w-full"
                    />
                  </td>
                </tr>
              </template>
              <div v-if="!form.codes.length" class="px-4 py-2">
                Sin códigos
              </div>
              <tr>
                <td class="border px-4 py-2" />
                <td class="border px-4 py-2 text-right">Totales</td>
                <td class="border px-4 py-2">{{ totals.total_appointments_sale }}</td>
                <td class="border px-4 py-2">{{ totals.contributed_citations }}</td>
                <td class="border px-4 py-2">{{ totals.financial_studies }}</td>
                <td class="border px-4 py-2">{{ totals.proposals_accepted }}</td>
                <td class="border px-4 py-2">{{ totals.orders }}</td>
                <td class="border px-4 py-2">{{ totals.mortgages }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'

export default {
  components: {
    Head,
    Link,
    TextInput,
  },
  layout: Layout,
  props: {
    storedForm: Object,
    auth: Object,
  },
  remember: 'form',
  data() {
    return {
      errors: false,
      form: this.$inertia.form({
        id: this.storedForm.id,
        active: this.storedForm.active,
        date: this.storedForm.date,
        codeBDT: this.storedForm.codeBDT,
        organization: this.storedForm.organization,
        signatures_month: this.storedForm.signatures_month,
        active_agents: this.storedForm.active_agents,
        contacts: this.storedForm.contacts,
        number_organizations: this.storedForm.number_organizations,
        total_orders_month: this.storedForm.total_orders_month,
        codes: this.storedForm.codes,
      }),
      totals: {
        total_appointments_sale: 0,
        contributed_citations: 0,
        financial_studies: 0,
        proposals_accepted: 0,
        orders: 0,
        mortgages: 0,
      },
    }
  },
  watch: {
    form: {
      handler() {
        this.updateTotals()
      },
      deep: true,
    },
    '$page.props.flash.error': {
      handler() {
        if(this.$page.props.flash.error) {
          this.errors = true
        }
      },
      deep: true,
    },
  },
  created() {
    this.form.codes.forEach(element => {
      element.mortgages = element.pivot.mortgages
      element.financial_studies = element.pivot.financial_studies
      element.orders = element.pivot.orders
      element.proposals_accepted = element.pivot.proposals_accepted
      element.contributed_citations = element.pivot.contributed_citations
      element.total_appointments_sale = element.pivot.total_appointments_sale
    })

    this.updateTotals()
  },
  methods: {
    updateTotals() {
      this.totals.total_appointments_sale = 0
      this.totals.contributed_citations = 0
      this.totals.financial_studies = 0
      this.totals.proposals_accepted = 0
      this.totals.orders = 0
      this.totals.mortgages = 0

      this.form.codes.forEach(element => {
        this.totals.total_appointments_sale += parseInt(element.total_appointments_sale || 0)
        this.totals.contributed_citations += parseInt(element.contributed_citations || 0)
        this.totals.financial_studies += parseInt(element.financial_studies || 0)
        this.totals.proposals_accepted += parseInt(element.proposals_accepted || 0)
        this.totals.orders += parseInt(element.orders || 0)
        this.totals.mortgages += parseInt(element.mortgages || 0)
      })
    },
    update() {
      this.form.put(`/formularios/${this.storedForm.id}`)
    },
    detach(codeId) {
      if(confirm('Estas seguro de desvincular este código?')) {
        this.form.post(`/desvincular/${this.storedForm.id}/codigo/${codeId}`)
        document.getElementById(`code-${codeId}`).remove()
      }
    },
    save() {
      this.form.put(`/formularios/${this.storedForm.id}/guardar`, {
        onSuccess: () => {
          if(!this.$page.props.flash.error) {
            this.form.active = 0
          }
        },
      })
    },
    reactivate() {
      this.form.put(`/formularios/${this.storedForm.id}/reactivar`)
    },
  },
}
</script>
